import type { TagSetsProps } from "~/areas/library/components/TenantTagSets/TagSets";
import { TagSets } from "~/areas/library/components/TenantTagSets/TagSets";
export function TagSetsPage({ spaceId, queryParams, setQueryParams, loaderData }: TagSetsProps) {
    return <TagSets spaceId={spaceId} queryParams={queryParams} setQueryParams={setQueryParams} loaderData={loaderData}/>;
}
